import React from 'react';
import './footerApp.css'

import { Layout } from 'antd';
const { Footer } = Layout;

const FooterApp = () => {
    return <Footer
        style={{
            textAlign: 'center',
            backgroundColor: 'white',
            color: '#3E246B',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '110px',
            borderTop: '1px solid #E8E8E8'
        }}
    >
        <span style={{ color: '#3E246B' }}>Mentoring ©{new Date().getFullYear()}</span>
        <span style={{ color: '#3E246B' }}>Todos los derechos reservados</span>
        <span style={{ color: '#9e9e9e', fontSize: '11px' }}>v3.6.1</span>
    </Footer>
}

export default FooterApp;